import { initializeApp } from 'firebase/app'
import { getFirestore, doc, onSnapshot } from 'firebase/firestore'
import { getAuth, signInWithCustomToken, signOut } from 'firebase/auth'

// Initalize and export Firebase.
const config = {
  authDomain: process.env.VUE_APP_FIRESTORE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIRESTORE_DATABASE_URL,
  storageBucket: process.env.VUE_APP_FIRESTORE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIRESTORE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIRESTORE_APP_ID,
  apiKey: process.env.VUE_APP_FIRESTORE_API_KEY,
  projectId: process.env.VUE_APP_FIRESTORE_PROJECT_ID
}
const app = initializeApp(config)

export class FirestoreClient {
  constructor(app) {
    this.app = app
    this.db = getFirestore(app)
  }

  signIn(token) {
    return new Promise((resolve, reject) => {
      const auth = getAuth(this.app)
      signInWithCustomToken(auth, token)
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  }

  signOut() {
    return new Promise((resolve, reject) => {
      const auth = getAuth(this.app)
      signOut(auth)
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  }

  createIfNeeded(doc, category, identifier, profile) {
    return new Promise((resolve, reject) => {
      if (doc.exists) {
        return resolve(doc)
      }

      let data = {
        refid: profile.refid,
        display: profile.display,
        updated_on: firebase.firestore.FieldValue.serverTimestamp()
      }
      doc(this.db, category, identifier)
        .set(data)
        .then(() => {
          resolve(doc)
        })
        .catch(reject)
    })
  }

  listen(category, identifier, callback, profile) {
    return new Promise((resolve, reject) => {
      const createIfNeeded = (doc, category, identifer, profile) =>
        this.createIfNeeded(doc, category, identifer, profile)
      let unsubscriber = onSnapshot(
        doc(this.db, category, identifier),
        function (doc) {
          createIfNeeded(doc, category, identifier, profile).then((res) => {
            callback(res)
          })
        },
        function (error) {
          reject(error)
        }
      )
      resolve(unsubscriber)
    })
  }
}

// Singleton client
export let client = new FirestoreClient(app)
